import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState , useRef} from 'react';
import { connect } from 'react-redux';
import {getGeneralData} from 'app/Components/Block/IMEIDeviceRepairBlock/IMEIDeviceRepairSlice';
import {setDeviceRepairSubscriber ,setDeviceRepairSubscribersList , initialState} from '../../../BusinessWorkOrderSystemSlice';
import { TextInputEnum , validateInput } from 'app/utilities/validation/InputValidation';
import TextInputWithButton from 'app/Components/Shared/TextInputWithButton/TextInputWithButton';
import {isMobile} from 'react-device-detect';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import DynamicElementList from 'app/Components/Shared/DynamicElementList/DynamicElementList';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import RadioInput from 'app/Components/Shared/RadioInput/RadioInput';
import openArrow from '../../../Icons/openArrow.svg';
import closeArrow from '../../../Icons/closeArrow.svg';
import {DeviceRepairSelectIssue} from './DeviceRepairSelectIssue';
import { radioInputOptions } from '../../../Constant/Constant';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {validateAccountToIMEIService} from 'app/Components/Block/IMEIDeviceRepairBlock/IMEIDeviceRepairSlice';
import {startPointEnum} from 'app/Components/Block/IMEIDeviceRepairBlock/IMEIDeviceRepairSlice';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';

const DeviceRepair = ({setDeviceRepairSubscriber,deviceRepairSubscribersList,causeSelectionList,getGeneralData,index,isSubmit,validateAccountToIMEIService,selectedHetPay}) => {
  const [causeOptions, setCauseOptions] = useState([]);
  var selectedSubscriber = deviceRepairSubscribersList[index] || initialState.deviceRepairSubscribersList[0];

  const subscriberRef = useRef(null);
  const serialNumberRef = useRef(null);

  const initialCause =  {
    selectedCauseType: '',
    selectedCauseSubType: '',
    }

   useEffect(() => {
        const getCauseOptions = async () => {
            await getGeneralData();
        }
        if(causeSelectionList.length === 0){
          getCauseOptions();
        }
    }, []);


    useEffect(() => {
     causeSelectionList?.map((item) => {
        let subOptions = [];
        item.causeSubType.map((sub) => {
          const subOption = {key: sub.causeSubTypeId, value: sub.causeSubTypeValue};
          subOptions.push(subOption);
        });
        let option = {key: item.causeTypeId, value: item.causeTypeValue, subOptions: subOptions};
        setCauseOptions((oldArray) => [...oldArray, option]);
      });
    }, [causeSelectionList]);


    useEffect(() => {
      const validateOnSubmit = async () => {
        if(isSubmit){
          var data = {
            ...selectedSubscriber,
            errors: {
              subscriber: validateInput(selectedSubscriber.subscriber, TextInputEnum.Phone, true),
              deviceSerialNumber: validateInput(selectedSubscriber.deviceSerialNumber, TextInputEnum.IMEI, true),
              securityCode: validateInput(selectedSubscriber.securityCode, TextInputEnum.SecurityCode, selectedSubscriber.securityCodeExist)
            }
          }
          setDeviceRepairSubscriber({index: index, data: data});
      };
    }
      
      validateOnSubmit();
    }, [isSubmit]);

    const changeSubscriberHandler = async (fieldName, fieldValue, validationType = null) => {
        var error = null;
        if(validationType){
          error = validateInput(fieldValue, validationType, true);
        }
      
        setDeviceRepairSubscriber({
          index: index,
          data: {
            ...selectedSubscriber,
            [fieldName]: fieldValue,
            errors: {
              ...selectedSubscriber.errors,
              ...(validationType && { [fieldName]: error })
            }
          }
        });
      }

    const saveSelectedCauseType = (data, index) => {
      var newCauseList = [];
      if(selectedSubscriber.causeList.length == 0){
        newCauseList = [{...initialCause ,...data}];
      }else{
        newCauseList=selectedSubscriber.causeList.map((item, idx) => {if(idx == index){return {...item, ...data}} else {return item}})
      }
       changeSubscriberHandler('causeList', newCauseList)
    }

    const validateSubscriber = (value) => {
      var isSubscriberExist = deviceRepairSubscribersList.some((subscriber, i) => i !== index && subscriber!="" && subscriber.subscriber === value);
      var error = null;
      if(isSubscriberExist){
        error = 'מספר מנוי זה כבר קיים';
      }else{
       error = validateInput(value, TextInputEnum.Phone, true); 
      }
      setDeviceRepairSubscriber({index: index, data: {...selectedSubscriber, subscriber: value, errors: {...selectedSubscriber.errors, subscriber: error}}});
    }

    const validateLastCause = () => {
      var lastCause = selectedSubscriber.causeList[selectedSubscriber.causeList.length - 1];
      if(lastCause.selectedCauseType == '' || lastCause.selectedCauseSubType == ''){
        changeSubscriberHandler('causeList', selectedSubscriber.causeList)
        return false;
       }
       return true;
    }
  
  return (
    <div className='device-repair-form'>
        <div className='header'>
          <span>פרטי מנוי {deviceRepairSubscribersList.length > 1 ? index + 1 : ''}</span>
          {deviceRepairSubscribersList.length > 1 && (
            <button className='open-close-btn' onClick={()=>{changeSubscriberHandler('open', !selectedSubscriber.open)}} >
              <Image src={selectedSubscriber.open ? closeArrow : openArrow} alt='open' />
            </button>
          )}
        </div>

        <TextInput
            placeholder='מספר מנוי'
            onChange={(e) => validateSubscriber(e.target.value)}
            value={selectedSubscriber.subscriber}
            name={'subscriber'}
            type="text"
            error={selectedSubscriber.errors?.subscriber}
            ref={subscriberRef}
            required={true}

        />

      {(selectedSubscriber.open || (index == 0 && deviceRepairSubscribersList.length == 1)) && ( <>
        <TextInput
            placeholder='מספר סידורי'
            onChange={(e) => changeSubscriberHandler('deviceSerialNumber', e.target.value, TextInputEnum.IMEI)}
            value={selectedSubscriber.deviceSerialNumber}
            name={'serialNumber'}
            type="text"
            error={selectedSubscriber.errors?.deviceSerialNumber}
            ref={serialNumberRef}
            required={true}
        />
        <DynamicElementList
                Component={DeviceRepairSelectIssue}
                componentProps={{
                  causeOptions,
                  selectedSubscriber,
                  saveSelectedCauseType : saveSelectedCauseType,
                  isSubmit : isSubmit
                 }}
                  validationBeforeAdd={() => {
                    return validateLastCause();
                  }}
                elementName={selectedSubscriber.causeList.length > 1 ? 'תקלה' : 'מה סוג התקלה?'}
                addButtonText="סוג תקלה נוסף"
                removeButtonText="הסר"
                setElements={(elements) => {
                  changeSubscriberHandler('causeList', elements)
                }}
                elements={selectedSubscriber.causeList}
                initialData={initialCause}
                isRequired={true}
         />
         
         {radioInputOptions.map((element , radioIndex) => (
          <div className={'radio-input-container'} key={radioIndex}>
            <span className={'m-title'}>{element.title}</span>
            {element.options.map((option) => (
              <RadioInput
              name={`${element.name}-${index}`} 
              value={option.value} 
              key={option.key}
              checked={selectedSubscriber[element.name] === option.value}
              onChange={(e) => changeSubscriberHandler(element.name, e.target.value === 'true' || e.target.value === true)} 
              label={option.key}
                id={`${element.name}-${option.key}-${index}`} />
            ))}
          </div>
        ))}
      

        {selectedSubscriber.securityCodeExist && (
          <div className="d-flex security-code">
              <span className={'cause-selection-subtitle'}>
                  מה קוד הנעילה שלך?<span className={'cellcom-color'}> * </span></span>
            <span className={'security-code-text'}>במידה והקוד הוא ציור יש להתייחס אליו{isMobile &&
              <br />} כספרות 1-9</span>
            <TextInput
              error={selectedSubscriber.errors?.securityCode}
              placeholder="נא להזין קוד "
              onChange={(e) => changeSubscriberHandler('securityCode', e.target.value, TextInputEnum.SecurityCode)}
              value={selectedSubscriber.securityCode}
              name={'securityCode'}
              type="text"
              required={selectedSubscriber.securityCodeExist ?? 'required'}
              disabled={!selectedSubscriber.securityCodeExist}
            />
          </div>
        )}

        <CheckBox
            checked={selectedSubscriber.clearContentApproved}
            label={`אני מאשר לאפס תכנים במידת הצורך`}
            id={`clearContentApproved_${index}`}
            onCheck={() => {
              changeSubscriberHandler('clearContentApproved', true)
            }}
            onUncheck={() => changeSubscriberHandler('clearContentApproved', false)}
          />
        </>
    )}


     
    </div>
  );
}

const mapStateToProps = (state) => ({
  deviceRepairSubscribersList: state.businessWorkOrderSystem.deviceRepairSubscribersList,
  causeSelectionList: state.iMEIDeviceRepair.causeSelectionList ?? [],
  selectedHetPay: state.portalsBlock.selectedHetPay,
});

const mapDispatchToProps = {
  setDeviceRepairSubscriber,
  getGeneralData,
  validateAccountToIMEIService

};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceRepair);




